Vue.component('pricelist-filter', {

    props: ["filterData", "flatData", "filterDataLoaded", "showFavorite"],

    data: function() {
        return {
            gv: gv,
            en: gv.en,
            filterCollapsedSelector: "#pl-filter-collapse"
        }
    },

    methods: {
        changePricelistView(type) {
            switch (type) {
                case "list":
                    if (!this.filterData.view.list) {
                        this.filterData.view.list = true;
                        this.filterData.view.cards = false;
                    }
                    break;
                case "cards":
                    if (!this.filterData.view.cards) {
                        this.filterData.view.list = false;
                        this.filterData.view.cards = true;
                    }
                    break;
            }
        },
        getViewFilterBtnActiveClass(type) {
            return this.filterData.view[type] ? "active" : "";
        },
        collapseFilter() {
            this.filterData.filterCollapsed = !this.filterData.filterCollapsed;
            if (this.filterData.filterCollapsed) {
                $(this.filterCollapsedSelector).collapse('show')
            } else {
                $(this.filterCollapsedSelector).collapse('hide')
            }
        },
        showCollapseFilter() {
            this.filterData.filterCollapsed = true;
            $(this.filterCollapsedSelector).collapse('show')
        },
        hideCollapseFilter() {
            this.filterData.filterCollapsed = false;
            $(this.filterCollapsedSelector).collapse('hide')
        },
        eachObject(obj, callBack) {
            for (let pp in obj) {
                if ( obj.hasOwnProperty(pp) ) {
                    callBack(obj[pp]);
                }
            }
        },
        resetFilters() {
            this.showFavorite.state = false;

            this.eachObject(this.filterData, (obj) => {

                if (typeof obj === "object") {
                    if (typeof obj.state !== "undefined") obj.state = false;
                    this.eachObject(obj, (o) => {
                        if (typeof o.state !== "undefined") o.state = false;
                    })
                }

                if (obj.label === "Jen volné") {
                    obj.state = true;
                    obj.available = true;
                }

            })
        },
        getVisibleFlatsCount() {
            let count = this.flatData.length;
            this.flatData.forEach((item) => {
                if (!item.visibility) count--
            });
            return count;
        },
        showFavorites() {
            this.resetFilters();
            this.hideCollapseFilter();
            pricelist.$set(this.showFavorite, "state", true);
            this.filterData.view.cards = true;
            this.filterData.view.list = false;
        },
        uncheckGroup(activeFilter, filterGroup) {
            for (let filter in filterGroup) {
                if (filter !== activeFilter) filterGroup[filter].state = 0;
            }
        }
    },

    filters: {},

    mounted() {},

    updated: function () {},

    watch: {
        filterDataLoaded: {
            handler: function () {
                if (this.filterData.filterCollapsed) this.showCollapseFilter();
            }
        }
    },

    template:
`
<div v-if="!showFavorite.state"> 
    <div class="row">
        <div class="col-sm-12 col-md-auto order-md-2 ml-auto text-right">
            <div class="pl-filter-flat-count">
                <span v-if="en">displayed {{getVisibleFlatsCount()}} out of {{flatData.length}}</span>
                <span v-else>zobrazeno bytů {{getVisibleFlatsCount()}} z {{flatData.length}}</span>
            </div>
        </div>
        <div class="col align-items-end d-flex order-md-1">
            <button type="button" class="btn btn-dropdown px-2 px-sm-4" v-bind:class="filterData.filterCollapsed ? 'up' : ''" v-on:click="collapseFilter">
                <span v-once v-if="en" class="d-none d-sm-inline">FILTER</span>
                <span v-once v-else class="d-none d-sm-inline">FILTR</span>
                <svg class="d-sm-none" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 1792 1792" width="20"><path fill="#ffffff" d="M1595 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"/></svg>
            </button>
        </div>
        <div class="col-auto ml-auto text-right align-items-end d-flex order-md-3">
            <button v-on:click="changePricelistView('cards')"
                    v-bind:class="getViewFilterBtnActiveClass('cards')"
                    type="button"
                    class="btn-filter-cards"><span></span><span></span></button>
            <button v-on:click="changePricelistView('list')"
                    v-bind:class="getViewFilterBtnActiveClass('list')"
                    type="button"
                    class="btn-filter-list"><span></span><span></span><span></span></button>
        </div>
    </div>
    
    <div class="row pl-filter collapse px-3 mx-0" id="pl-filter-collapse">
        <div class="col-12 col-md-8 py-4">
        
            <!--
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3">Building:</div>
                <div v-once v-else class="col-12 col-md-3">Budova:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.building"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input type="checkbox" class="custom-control-input">
                        <label v-html="filter.label" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            -->
         
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Layout:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Dispozice:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.disposition"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3 text-lowercase">
                        <input v-model="filter.state" v-bind:id="'filter-'+key" type="checkbox" class="custom-control-input">
                        <label v-html="filter.label" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            
            
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Floor:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Podlaží:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.floor"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input v-model="filter.state" v-bind:id="'filter-'+key" type="checkbox" class="custom-control-input">
                        <label v-html="filter.label" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            
            
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Number of beds:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Počet lůžek:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.beds"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input v-model="filter.state" v-bind:id="'filter-'+key" type="checkbox" class="custom-control-input">
                        <label v-html="filter.label" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            
            
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Equipment:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Vybavení:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.accessories"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input v-model="filter.state" v-bind:id="'filter-'+key" type="checkbox" class="custom-control-input">
                        <label v-if="en" v-html="filter.labelEn" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                        <label v-else v-html="filter.label" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            
            <!--
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Price:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Cena:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.price"
                         v-if="filter.available"
                         class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input v-model="filter.state" v-bind:id="'filter-'+key" type="checkbox" class="custom-control-input" @change="uncheckGroup(key, filterData.price)">
                        <label v-if="en" v-html="filter.labelEn" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                        <label v-else v-html="filter.label" v-bind:for="'filter-'+key" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
        
            <div class="row">
                <div v-once v-if="en" class="col-12 col-md-3 mt-3 mt-md-0">Area:</div>
                <div v-once v-else class="col-12 col-md-3 mt-3 mt-md-0">Užitná plocha:</div>
                <div class="col">
                    <div v-for="(filter, key) in filterData.area"
                         v-if="filter.available"
                        class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3">
                        <input type="checkbox" class="custom-control-input" @change="uncheckGroup(key, filterData.area)">
                        <label v-if="en" v-html="filter.labelEn" class="custom-control-label"></label>
                        <label v-else v-html="filter.label" class="custom-control-label"></label>
                    </div>
                </div>
            </div>
            -->
            
        </div>
        <div class="col-auto ml-auto align-self-end py-4">
            <div class="custom-control custom-checkbox unicity-checkbox d-inline-block mr-3" v-if="filterData.onlyFree.available">
                <input v-model="filterData.onlyFree.state" id="filter-onlyFree" type="checkbox" class="custom-control-input">
                <label v-if="en" for="filter-onlyFree" class="custom-control-label">{{filterData.onlyFree.labelEn}}</label>
                <label v-else for="filter-onlyFree" class="custom-control-label">{{filterData.onlyFree.label}}</label>
            </div>
                       
            <button class="btn btn-uni-outline" v-on:click="resetFilters()">
                <span v-once v-if="en">Reset</span>
                <span v-once v-else>Resetovat</span>
            </button>
        </div>
    </div>
</div>
`
});

/* global gv */
/* global Vue */

Vue.component('pricelist-selection', {

    props: ["filterData", "flatData", "showFavorite", "filterDataLoaded"],

    data: function () {
        return {
            gv: gv,
            en: gv.en,
            selectionCollapsedSelector: "#pls-collapse",
            selectedFlat: {},
            selectedFlatElement: null,
            selectedFloor: "",
            selectedFloorNumber: 0,
            selectedBuilding: "",
            applyingFromLastSelected: false,
            buildingFloorStatesDone: false,
        }
    },

    methods: {
        collapseSelection() {
            this.filterData.selectionCollapsed = !this.filterData.selectionCollapsed;
            if (this.filterData.selectionCollapsed) {
                $(this.selectionCollapsedSelector).collapse('show')
            } else {
                $(this.selectionCollapsedSelector).collapse('hide')
            }
        },
        showCollapseSelection() {
            this.filterData.selectionCollapsed = true;
            $(this.selectionCollapsedSelector).collapse('show')
        },
        hideCollapseSelection() {
            this.filterData.selectionCollapsed = false;
            $(this.selectionCollapsedSelector).collapse('hide')
        },
        selectFloor(building, floor) {
            if (this.selectedFloor !== '') document.getElementById('pls-mapping').append(document.getElementById(this.selectedFloor))

            this.filterData.selectionSelectedBuilding = building;
            this.filterData.selectionSelectedFloor = floor;
            this.selectedFloor = building + '-' + floor

            this.$refs.selectFloor.append(document.getElementById(this.selectedFloor))
        },
        redirect() {
            location.href = this.en ? this.selectedFlat.urlEn : this.selectedFlat.url;
        },
        setSelectedFlatAreaElement(target) {
            if (this.selectedFlatElement) this.selectedFlatElement.setAttribute('class', 'pls-flat');

            if (typeof target === 'string') {
                let flatByName = this.flatData.find(function (flat) {
                    return flat.name.toLowerCase() === target.toLowerCase();
                });
                this.selectedFlatElement = flatByName.flatArea;
            } else {
                this.selectedFlatElement = target;
            }

            if (this.selectedFlatElement) this.selectedFlatElement.setAttribute('class', 'pls-flat active')
        },
        selectFlat(flatArea) {
            this.setSelectedFlatAreaElement(flatArea);
            this.selectedFlat = this.findFlatByName(this.selectedFlatElement.dataset.flat);
            this.setFilterDataFlatName();
        },
        findFlatByName(name) {
            return this.flatData.find(function (flat) {
                return flat.name.toLowerCase() === name.toLowerCase();
            });
        },
        selectFirstVisibleFlatFromFloor(building, floor) {
            let selected = false;
            this.flatData.forEach((flat) => {
                if (!selected && flat.building.toLowerCase() === building && flat.floor === floor) {
                    selected = true;
                    this.selectedFlat = flat;
                    this.setSelectedFlatAreaElement(flat.name.toLowerCase());
                    this.setFilterDataFlatName();
                    return false;
                }
            });

            if (!selected) this.selectedFlat = {}
        },
        getFloorActiveClass(building, floor) {
            return (this.selectedFloor && building === this.filterData.selectionSelectedBuilding && floor === this.filterData.selectionSelectedFloor) ? 'active' : '';
        },
        getBuildingActiveClass(building) {
            return (this.selectedFloor && building === this.filterData.selectionSelectedBuilding) ? 'active' : '';
        },
        setLastSelectedData() {
            if (this.filterData.selectionSelectedBuilding !== "" && this.filterData.selectionSelectedFloor !== "" && this.filterData.selectionSelectedFlatName !== "") {
                this.applyingFromLastSelected = true;
                this.selectFloor(this.filterData.selectionSelectedBuilding, this.filterData.selectionSelectedFloor);
                this.selectedFlat = this.findFlatByName(this.filterData.selectionSelectedFlatName);
            }
        },
        setFilterDataFlatName() {
            if (this.selectedFlatElement) this.filterData.selectionSelectedFlatName = this.selectedFlatElement.dataset.flat.toLowerCase();
        },
        setBuildingFloorStates() {
            if (this.buildingFloorStatesDone || !this.flatData) return;

            this.buildingFloorStatesDone = true;

            this.flatData.forEach((flat) => {
                if (!this.$options.mappings) {
                    return;
                }

                flat.flatArea = this.$options.mappings.querySelector('[data-flat="' + flat.name.toLowerCase() + '"]');
                let flatAreaTrigger = this.$options.mappings.querySelector('[data-flat-trigger="' + flat.name.toLowerCase() + '"]');

                if (flat.flatArea !== null) {
                    flat.flatArea.setAttribute('data-state', flat.statusNum);
                    if (flatAreaTrigger) {
                        flatAreaTrigger.setAttribute('class', 'available');
                        flatAreaTrigger.addEventListener('click', (e) => this.redirect(e));
                        flatAreaTrigger.addEventListener('mouseenter', (e) => this.selectFlat(flat.flatArea));
                    }
                }
            });
        }
    },

    mappings: null,

    filters: {
        flatState: (val) => {
            if (parseInt(val) === 0) return gv.en ? "Vacant" : "Volný";
            else if (parseInt(val) === 1) return gv.en ? "Reserved" : "Rezervovaný";
            else if (parseInt(val) === 2) return gv.en ? "Occupied" : "Obsazený";
            else return val;
        },
        dashZero: (val) => {
            return parseInt(val) === 0 ? "-" : val;
        },
        moneyFormat: (val) => {
            return val ? parseInt(val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace('.00', '') : '-';
        }
    },

    mounted() {
        this.$options.mappings = document.getElementById('pls-mapping');
    },

    updated: function () {
    },

    watch: {
        filterDataLoaded: {
            handler: function () {
                this.setBuildingFloorStates();

                if (this.filterData.selectionCollapsed) {

                    this.showCollapseSelection();
                    this.setLastSelectedData();
                }
            }
        },
        flatData(val) {
            if (val) this.setBuildingFloorStates();
        },
        selectedFloor(val) {
            if (val) {
                this.$nextTick(() => {
                    if (this.applyingFromLastSelected) {
                        this.setSelectedFlatAreaElement(this.filterData.selectionSelectedFlatName);
                        this.applyingFromLastSelected = false;
                    } else {
                        this.selectFirstVisibleFlatFromFloor(this.filterData.selectionSelectedBuilding, this.filterData.selectionSelectedFloor);
                    }
                })
            }
        }
    },

    template:
        `
<div v-bind:class="showFavorite.state ? 'd-none' : ''">
    <div class="d-none d-md-block">
        <div class="row">
            <div class="col align-items-end d-flex order-md-1">
                <button type="button" class="btn btn-dropdown px-2 px-sm-4" v-bind:class="filterData.selectionCollapsed ? 'up' : ''" v-on:click="collapseSelection">
                    <span v-once v-if="en" class="d-none d-sm-inline">INTERACTIVE SELECTION</span>
                    <span v-once v-else class="d-none d-sm-inline">INTERAKTIVNÍ VÝBĚR</span>
                    <svg class="d-sm-none" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 1792 1792" width="20"><path fill="#ffffff" d="M1595 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"/></svg>
                </button>
            </div>
        </div>
        
        <div class="row pl-selection collapse mx-0 ovf-h" id="pls-collapse">
        
            <div class="col-12 pls-buildings p-0 position-relative">
                <span v-once v-if="en" class="pls-hint">Click to choose a floor</span>
                <span v-once v-else class="pls-hint">Kliknutím vyberete podlaží</span>
                
                <div class="pls-buildings-mapping">
                    <img src="#" v-bind:src="gv.content_url + '/images/buildings/selection.jpg'" alt="">
                    
                    <div v-bind:class="getBuildingActiveClass('c1')" class="pls-building-name c1">C1</div>
                    <div v-bind:class="getBuildingActiveClass('c2')" class="pls-building-name c2">C2</div>
                    <div v-bind:class="getBuildingActiveClass('d')" class="pls-building-name d">D</div>
                    
                    <svg class="pls-buildings-map" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1600 452" xml:space="preserve">
                                
                        <polygon class="pls-floor" @click="selectFloor('c1', 1)" v-bind:class="getFloorActiveClass('c1', 1)" points="523.3,310 409.5,301.5 388.5,301.5 369.5,301.5 332.9,301.4 332.9,304.5 305,304.6 163.5,306.5 163.5,307.5 125.5,307.5 116.5,307.5 91,308 90.6,308.3 91,342 390.5,339.5 408.5,340.5 523.3,343 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c1', 2)" v-bind:class="getFloorActiveClass('c1', 2)" points="533.5,288 523.2,285.3 523.2,282.5 409.3,267.6 409.3,271 368.3,270.5 368.3,268.4 333.1,268.6 333.1,273.6 282.1,274.9 273.4,275.2 163.2,278.5 163.3,281.6 90.6,282.5 91,318.5 90.9,308.4 91.3,308 116.8,307.5 125.8,307.5 163.8,307.5 163.8,306.5 305.2,304.7 333.1,304.5 333.1,301.5 369.8,301.5 388.8,301.5 409.8,301.5 523.3,310 523.2,291.3 533.5,290.7 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c1', 3)" v-bind:class="getFloorActiveClass('c1', 3)" points="90.6,282.5 163.3,281.6 163.2,278.5 273.4,275.2 282.1,274.9 333.1,273.6 333.1,268.6 368.3,268.4 368.3,270.5 409.3,271 409.3,267.6 523.2,282.5 523.3,256.5 409,237 388.5,237.7 368,237.3 332.9,238.5 332.8,243.1 303.9,243.4 290.6,242.5 163,248.4 163,252.5 125.1,253 115.5,253 90,254 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c1', 4)" v-bind:class="getFloorActiveClass('c1', 4)" points="533.4,236.2 523.2,232.3 523.2,230.7 408.6,205 405.9,205 392.5,203.9 373.1,204.2 367.9,203.8 367.9,205.6 332.8,206.5 332.8,208 303.2,208.8 303.3,212.4 281.4,213 272.9,212.7 162.9,221.4 162.9,226 143,226.6 130.3,225.6 115.2,225.8 89.8,226.8 90,254 115.5,253 125.1,253 163,252.5 163,248.4 290.6,242.5 303.9,243.4 332.8,243.1 332.9,238.5 368,237.3 388.5,237.7 409,237 523.3,256.5 523.2,239.4 533.3,238.5 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c1', 5)" v-bind:class="getFloorActiveClass('c1', 5)" points="89.8,226.8 115.2,225.8 130.3,225.6 143,226.6 162.9,226 162.9,221.4 272.9,212.7 281.4,213 303.3,212.4 303.2,208.8 332.8,208 332.8,206.5 367.9,205.6 367.9,203.8 373.1,204.2 392.5,203.9 405.9,205 408.6,205 523.2,230.7 523.3,203.4 407.2,170.3 387,170.8 367.2,164.6 89.7,197.2 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c1', 6)" v-bind:class="getFloorActiveClass('c1', 6)" points="494,184.5 494,163 447,146 429,148 411,141 403,143 368,130 359,131 356,129 168,156 89,170 89.7,197.2 367.2,164.6 387,170.8 407.2,170.3 523.3,203.4 523.3,193.2 	"/>
                        
                        <polygon class="pls-floor" @click="selectFloor('c2', 1)" v-bind:class="getFloorActiveClass('c2', 1)" points="1167.3,310.9 1156.3,310.7 1156.2,286.6 1105,285.8 1100.2,286.2 1061.1,285.1 1061,289.8 1028.2,289.8 1028.2,284.6 870.1,282.2 870.1,286.4 832.2,286.3 832.1,281.6 782,281.6 782,280.9 699,280.4 698.8,320.5 1167.3,324 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c2', 2)" v-bind:class="getFloorActiveClass('c2', 2)" points="699,280.4 782,280.9 782,281.6 832.1,281.6 832.2,286.3 870.1,286.4 870.1,282.2 1028.2,284.6 1028.2,289.8 1061,289.8 1061.1,285.1 1100.2,286.2 1105,285.8 1156.2,286.6 1156.2,264.9 1163.7,262.2 1145.4,262.2 1145.4,255.9 1108,255.1 1107.9,261.1 1071,260.7 1070.9,254.7 1030.5,254.3 1030.6,253.2 983.4,252.1 983.4,257.4 916.5,256.4 916.5,249.5 863.8,248.7 863.8,248.9 816.7,247.6 816.7,252.4 781.6,252.1 781.5,246.8 733.7,246.1 733.7,251.1 706.7,251 706.8,245 698.8,244.8 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c2', 3)" v-bind:class="getFloorActiveClass('c2', 3)" points="1156.8,249.1 1156.8,228.3 1105.9,226.7 1099.9,226.4 1062.2,225 1062.1,228.5 1030.1,228.1 1030.1,222.2 870,217.3 870,222.9 833.1,222.1 833.1,217.2 782.5,216.1 782.5,213.5 698.8,212.2 698.8,244.8 706.8,245 706.7,251 733.7,251.1 733.7,246.1 781.5,246.8 781.6,252.1 816.7,252.4 816.7,247.6 863.8,248.9 863.8,248.7 916.5,249.5 916.5,256.4 983.4,257.4 983.4,252.1 1030.6,253.2 1030.5,254.3 1070.9,254.7 1071,260.7 1107.9,261.1 1108,255.1 1145.4,255.9 1145.4,262.2 1163.7,262.2 1163.9,262.1 1163.9,249.1 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c2', 4)" v-bind:class="getFloorActiveClass('c2', 4)" points="1146,196 1108.6,194.3 1108.7,200.2 1071.8,199.4 1071.8,194.7 1031.1,193.6 1031.1,191.3 984.4,189.9 984.4,194.8 917.1,193.5 917.1,186.7 864,184.8 864,185.3 816.7,184.3 816.7,186.7 781.8,186.3 781.7,180.2 733.6,178.6 733.7,186.7 707,186.7 707.1,178.2 698.8,178.1 698.8,212.2 782.5,213.5 782.5,216.1 833.1,217.2 833.1,222.1 870,222.9 870,217.3 1030.1,222.2 1030.1,228.1 1062.1,228.5 1062.2,225 1099.9,226.4 1105.9,226.7 1156.8,228.3 1156.7,207.1 1164.7,202.8 1146.1,202.5 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c2', 5)" v-bind:class="getFloorActiveClass('c2', 5)" points="707.1,178.2 707,186.7 733.7,186.7 733.6,178.6 781.7,180.2 781.8,186.3 816.7,186.7 816.7,184.3 864,185.3 864,184.8 917.1,186.7 917.1,193.5 984.4,194.8 984.4,189.9 1031.1,191.3 1031.1,193.6 1071.8,194.7 1071.8,199.4 1108.7,200.2 1108.6,194.3 1146,196 1146.1,202.5 1164.7,202.8 1164.9,189.5 1157.8,189.5 1157.9,163.4 966.2,154.9 703.3,144 699,155.9 698.8,178.1 	"/>
                        <polygon class="pls-floor" @click="selectFloor('c2', 6)" v-bind:class="getFloorActiveClass('c2', 6)" points="703.3,144 966.2,154.9 1157.8,163.4 1157.8,161.5 1147.9,161.4 1148,131.6 1099.8,130.4 1099.7,126 801.7,107.9 774.5,107 771.6,109.7 734.1,107.6 730.8,122 725.1,122 724.1,128.1 714.5,127.7 714.2,122.9 702.9,123.1 699.1,145.7 699.1,155.8 	"/>
                            
                        <polygon class="pls-floor" @click="selectFloor('d', 1)" v-bind:class="getFloorActiveClass('d', 1)" points="1520.9,286.4 1511.8,287.2 1494.1,286.9 1494.1,286.3 1489.8,286.2 1489.8,290.8 1436.8,289.9 1436.8,284.9 1429.2,284.8 1420.8,285.1 1362.3,284 1323,286.4 1293.6,286.4 1232,292.9 1228.4,292.9 1228.4,314.1 1230.5,314.1 1230.5,322.3 1330.2,318.8 1557,320.8 1556.5,287.3 	"/>
                        <polygon class="pls-floor" @click="selectFloor('d', 2)" v-bind:class="getFloorActiveClass('d', 2)" points="1293.6,286.4 1323,286.4 1362.3,284 1420.8,285.1 1429.2,284.8 1436.8,284.9 1436.8,289.9 1489.8,290.8 1489.8,286.2 1494.1,286.3 1494.1,286.9 1511.8,287.2 1520.9,286.4 1556.5,287.3 1556,260.5 1527.1,259.6 1527.1,263.9 1493.5,263.5 1493.5,258.5 1430.5,257.1 1430.5,260.9 1399.5,260.4 1399.5,255.6 1362.3,254.4 1334.6,257.5 1334.5,263.5 1328.8,264.1 1299.4,263.7 1299.3,258.9 1293.6,258.9 1232.3,267.1 1228.4,267.6 1228.4,292.9 1232,292.9 	"/>
                        <polygon class="pls-floor" @click="selectFloor('d', 3)" v-bind:class="getFloorActiveClass('d', 3)" points="1293.6,258.9 1299.3,258.9 1299.4,263.7 1328.8,264.1 1334.5,263.5 1334.6,257.5 1362.3,254.4 1399.5,255.6 1399.5,260.4 1430.5,260.9 1430.5,257.1 1493.5,258.5 1493.5,263.5 1527.1,263.9 1527.1,259.6 1556,260.5 1555.5,233.1 1520.2,232.3 1511.2,232.3 1493.1,232.3 1493.1,229.9 1488.1,229.8 1488.2,235.5 1436.6,234.6 1436.6,228.7 1429.1,228.5 1420.6,229.2 1399.8,229 1399.8,227.5 1362.3,226.5 1323,232.4 1293.6,231.9 1232.6,243.2 1228.4,244.5 1228.4,267.6 1232.3,267.1 	"/>
                        <polygon class="pls-floor" @click="selectFloor('d', 4)" v-bind:class="getFloorActiveClass('d', 4)" points="1293.6,231.9 1323,232.4 1362.3,226.5 1399.8,227.5 1399.8,229 1420.6,229.2 1429.1,228.5 1436.6,228.7 1436.6,234.6 1488.2,235.5 1488.1,229.8 1493.1,229.9 1493.1,232.3 1511.2,232.3 1520.2,232.3 1555.5,233.1 1555.5,206.5 1526,205.7 1526,209 1492.5,208.1 1492.5,202.8 1429.8,201.1 1429.8,203.7 1399.3,203.3 1399.3,198.7 1362.3,197.1 1335,203.7 1335,208.7 1323,211.6 1299.8,211.4 1299.9,205.2 1293.6,205.2 1233.1,218.9 1228.4,221.3 1228.4,244.5 1232.6,243.2 	"/>
                        <polygon class="pls-floor" @click="selectFloor('d', 5)" v-bind:class="getFloorActiveClass('d', 5)" points="1293.6,205.2 1299.9,205.2 1299.8,211.4 1323,211.6 1335,208.7 1335,203.7 1362.3,197.1 1399.3,198.7 1399.3,203.3 1429.8,203.7 1429.8,201.1 1492.5,202.8 1492.5,208.1 1526,209 1526,205.7 1555.5,206.5 1555,178.1 1362.3,169 1323,180.7 1293.6,179.1 1234.2,199.2 1228.4,202 1228.4,221.3 1233.1,218.9 	"/>
                        <polygon class="pls-floor" @click="selectFloor('d', 6)" v-bind:class="getFloorActiveClass('d', 6)" points="1228.4,202 1234.2,199.2 1293.6,179.1 1323,180.7 1362.3,169 1555,178.1 1554.8,169.2 1532.3,169 1532.3,152.3 1526,152.4 1526,148.1 1502.4,146.1 1502.4,143.3 1374.9,134.8 1357.1,141.5 1342.9,141.5 1312.2,150.6 1301.5,150 1278.1,155.7 1265.2,154.9 1252.1,159.7 1240.5,159.7 1234.4,162.4 1234.4,166 1233,167 1233,195.1 1228.4,197 	"/>
                    </svg>
                </div>
            </div>
            
            <div class="col-12 pls-floors position-relative">
            
                <div v-if="selectedFloor && selectedFlat.name">
                    <span v-once v-if="en" class="pls-hint">Click to choose an apartment details</span>
                    <span v-once v-else class="pls-hint">Kliknutím vyberete detail bytu</span>            
                </div>
                
                <div class="row" v-bind:class="(selectedFloor && selectedFlat.name) ? 'pt-5' : ''">
                    <div class="col-8 mx-auto">
                        <div class="pls-floor-info" v-bind:class="'building-'+filterData.selectionSelectedBuilding">
                            <div>{{filterData.selectionSelectedBuilding}}</div>
                            <div>{{filterData.selectionSelectedFloor}}.NP</div>
                        </div>
                        <div ref="selectFloor"></div>
                    </div>
                </div>
            </div>
            
            <div class="col-12 pls-info py-3" v-if="selectedFloor && selectedFlat.name">
                <div class="row">
                    <div class="ml-auto"></div>
                    <div class="pls-info-col col-auto">BYT {{selectedFlat.name}}</div>
                    <div class="pls-info-col col-auto" v-bind:class="'state-'+selectedFlat.statusNum">{{selectedFlat.statusNum | flatState}}</div>
                    <div class="pls-info-col col-auto">{{selectedFlat.disposition}}</div>
                    <div class="pls-info-col col-auto">{{selectedFlat.area}} m<sup>2</sup></div>
                    <div class="pls-info-col col-auto" v-if="en && selectedFlat.price">from CZK {{selectedFlat.price | moneyFormat}}</div>
                    <div class="pls-info-col col-auto" v-if="!en && selectedFlat.price">od {{selectedFlat.price | moneyFormat}} Kč / měsíc</div>
                    <div class="mr-auto"></div>
                </div>
            </div>
            
        </div>
    
    </div>
</div>
`
});

Vue.component('pricelist-table', {

    props: ["filterData", "flatData", "detailFlat", "favorite", "showFavorite", "loader"],

    data: function() {
        return {
            gv: gv,
            en: gv.en,
            placeholderUrl: gv.content_url + "/images/design/vz_byt_(15)_(1).jpg",
            asc: true,
            pager: {
                visibleFlats: 0,
                actualPage: 0,
                pages: [],
                perPage: 9
            },
        }
    },

    methods: {
        sortBy(val) {
            this.asc = !this.asc;
            this.flatData.sort((a, b) => {
                if (a[val] < b[val]) return this.asc ? -1 : 1;
                if (a[val] > b[val]) return this.asc ? 1 : -1;
                return 0;
            })
        },
        filterFlatData() {

            this.pager.visibleFlats = this.flatData.length;

            let buildingFilter = [];
            for (let prop in this.filterData.building) {
                if (this.filterData.building.hasOwnProperty(prop)) {
                    if (this.filterData.building[prop].state) buildingFilter.push(this.filterData.building[prop].value);
                }
            }

            let dispositionFilter = [];
            for (let prop in this.filterData.disposition) {
                if (this.filterData.disposition.hasOwnProperty(prop)) {
                    if (this.filterData.disposition[prop].state) dispositionFilter.push(this.filterData.disposition[prop].value);
                }
            }

            let floorFiler = [];
            for (let prop in this.filterData.floor) {
                if (this.filterData.floor.hasOwnProperty(prop)) {
                    if (this.filterData.floor[prop].state) floorFiler.push(this.filterData.floor[prop].value);
                }
            }

            let priceFiler = [];
            for (let prop in this.filterData.price) {
                if (this.filterData.price.hasOwnProperty(prop)) {
                    if (this.filterData.price[prop].state) priceFiler.push(this.filterData.price[prop].min);
                }
            }

            let areaFilter = [];
            for (let prop in this.filterData.area) {
                if (this.filterData.area.hasOwnProperty(prop)) {
                    if (this.filterData.area[prop].state) {
                        areaFilter.push([this.filterData.area[prop].min, this.filterData.area[prop].max]);
                    }
                }
            }

            let bedsFilter = [];
            for (let prop in this.filterData.beds) {
                if (this.filterData.beds.hasOwnProperty(prop)) {
                    if (this.filterData.beds[prop].state) bedsFilter.push(this.filterData.beds[prop].value);
                }
            }

            let accessoriesFilter = [];
            for (let prop in this.filterData.accessories) {
                if (this.filterData.accessories.hasOwnProperty(prop)) {
                    if (this.filterData.accessories[prop].state) accessoriesFilter.push(this.filterData.accessories[prop].value);
                }
            }

            let onlyFreeFilter = false;

            if (!buildingFilter.length &&
                !dispositionFilter.length &&
                !floorFiler.length &&
                !priceFiler.length &&
                !areaFilter.length &&
                !bedsFilter.length &&
                !accessoriesFilter.length) onlyFreeFilter = true;

            let visibilityIndex = 0;

            this.flatData.forEach((flat) => {
                if (!buildingFilter.length &&
                    !dispositionFilter.length &&
                    !floorFiler.length &&
                    !areaFilter.length &&
                    !bedsFilter.length &&
                    !accessoriesFilter.length &&
                    !priceFiler.length &&
                    !this.filterData.onlyFree.state) {
                    flat.visibility = true;
                    flat.visibilityIndex = visibilityIndex++;
                }
                else {
                    let display = false;
                    let displayState = [];

                    if ((buildingFilter.length && buildingFilter.indexOf(flat.building.toLowerCase()) >= 0)) {
                        display = true;
                        displayState.push(1);
                    } else if (buildingFilter.length) {
                        displayState.push(0);
                    }

                    if ((dispositionFilter.length && dispositionFilter.indexOf(flat.disposition.toLowerCase()) >= 0)) {
                        display = true;
                        displayState.push(1);
                    } else if (dispositionFilter.length) {
                        displayState.push(0);
                    }

                    if ((floorFiler.length && floorFiler.indexOf(flat.floor) >= 0)) {
                        display = true;
                        displayState.push(1);
                    } else if (floorFiler.length) {
                        displayState.push(0);
                    }

                    if (priceFiler.length) {
                        priceFiler.forEach((minPrice) => {
                            if (flat.price >= minPrice) {
                                display = true;
                                displayState.push(1);
                            } else {
                                displayState.push(0);
                            }
                        });
                    }

                    if (areaFilter.length) {
                        areaFilter.forEach((areaRange) => {
                            if (flat.area > areaRange[0] && flat.area < areaRange[1]) {
                                display = true;
                                displayState.push(1);
                            } else {
                                displayState.push(0);
                            }
                        });
                    }

                    if ((bedsFilter.length && bedsFilter.indexOf(flat.bedsShort) >= 0)) {
                        display = true;
                        displayState.push(1);
                    } else if (bedsFilter.length) {
                        displayState.push(0);
                    }

                    if (accessoriesFilter.length) {
                        accessoriesFilter.forEach((accessory) => {
                            if (flat.accessories.hasOwnProperty(accessory)) {
                                display = true;
                                displayState.push(1);
                            } else {
                                displayState.push(0);
                            }
                        });
                    }

                    if (this.filterData.onlyFree.state && onlyFreeFilter && flat.statusNum === 0) {
                        displayState.push(1);
                    } else if (this.filterData.onlyFree.state && display && flat.statusNum !== 0) {
                        displayState.push(0);
                    }

                    // all filters
                    // if (!display) {
                    //     flat.visibilityIndex = -1;
                    //     this.pager.visibleFlats -= 1;
                    // } else {
                    //     flat.visibilityIndex = visibilityIndex++;
                    // }

                    // strict filters
                    if (displayState.indexOf(0) > -1 || !displayState.length) {
                        flat.visibilityIndex = -1;
                        this.pager.visibleFlats -= 1;
                        display = false;
                    } else {
                        flat.visibilityIndex = visibilityIndex++;
                        display = true;
                    }

                    flat.visibility = display;
                }
            });

            this.setPager();

        },
        setPager() {

            this.pager.actualPage = 0;
            this.pager.pages = [];

            let pages = [];
            for (let i = 0; i < this.pager.visibleFlats; i++) {
                if (i%this.pager.perPage === 0) {
                    pages.push(0)
                }
            }
            pages[this.pager.actualPage] = 1;
            this.pager.pages = pages;
        },
        setPage(target) {
            if (target === "next") {
                target = this.pager.actualPage + 1;
                if (target > this.pager.pages.length - 1) return false;
                $('html, body').animate({scrollTop: $('#change-page-anchor').offset().top}, 400);
            } else if (target === "prev") {
                target = this.pager.actualPage - 1;
                if (target < 0) return false;
                $('html, body').animate({scrollTop: $('#change-page-anchor').offset().top}, 400);
            }
            this.pager.pages[this.pager.actualPage] = 0;
            this.pager.actualPage = target;
            Vue.set(this.pager.pages, target, 1);
        },
        isAtPage(index) {
            let from = this.pager.actualPage * this.pager.perPage;
            let to = from + this.pager.perPage - 1;
            return index >= from && index <= to;
        },
        redirectToFlatDetail(flat, clickType = 'undefined') {
            this.dataLayerDetailFlat(flat, clickType);
            location.href = this.en ? flat.urlEn : flat.url;
        },
        dataLayerDetailFlat(flat, clickType) {
            dataLayer.push({
                'typZobrazeni' : this.filterData.view.list ? 'Tabulka' : 'Dlaždice',
                'typKliknuti' : clickType,
                'typBytu' : flat.name,
                'event' : 'detailBytu'
            });
        },
        isCardVisible(flat) {
            if (this.showFavorite.state) {
                return flat.favorite;
            } else return flat.visibility && this.isAtPage(flat.visibilityIndex)
        },
        hideFavorite() {
            pricelist.$set(this.showFavorite, "state", false);
        },
        getStateClass(state) {
            return `pl-state-${state}`;
        },
        totalPrice: (flat) => {
            return flat.price ? parseInt(flat.price) : '-'
        }
    },

    filters: {
        flatState: (val) => {
            if (parseInt(val) === 0) return gv.en ? "Vacant" : "Volný";
            else if (parseInt(val) === 1) return gv.en ? "Reserved" : "Rezervovaný";
            else return val;
        },
        dashZero: (val) => {
            return parseInt(val) === 0 ? "-" : val;
        },
        moneyFormat: (val) => {
            return val ? parseInt(val).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace('.00', '') : '-';
        },
    },

    mounted() {},

    updated: function () {},

    watch: {
        filterData: {
            handler: function () {
                this.filterFlatData();
                this.setPager();
            },
            deep: true
        }
    },

    template:
`
<div class="pb-5 pt-4" id="change-page-anchor">

    <div v-if="!showFavorite.state && filterData.view && filterData.view.list">
        <div id="pl-table-header" class="row m-0">
            <div v-on:click="sortBy('name')" class="pl-table-header-col col">
                <span v-once v-if="en">Apart. NO.</span><span v-else>č.bytu</span>
            </div>
            <div v-on:click="sortBy('building')" class="pl-table-header-col col d-none d-lg-block">
                <span v-once v-if="en">building</span><span v-else>budova</span>
            </div>
            <div v-on:click="sortBy('floor')" class="pl-table-header-col col d-none d-lg-block">
                <span v-once v-if="en">floor</span><span v-else>podlaží</span>
            </div>
            <div v-on:click="sortBy('orientation')" class="pl-table-header-col col d-none d-sm-block">
                <span v-once v-if="en">facing</span><span v-else>orientace</span>
            </div>
            <div v-on:click="sortBy('disposition')" class="pl-table-header-col col">
                <span v-once v-if="en">layout</span><span v-else>dispozice</span>
            </div>
            <div v-on:click="sortBy('area')" class="pl-table-header-col col">
                <span v-once v-if="en">area</span><span v-else>plocha</span> <br class="d-sm-none">(<span class="text-lowercase">m</span><sup>2</sup>)
            </div>
            <div v-on:click="sortBy('balcony')" class="pl-table-header-col col d-none d-md-block">
                <span v-once v-if="en">balcony</span><span v-else>balkon</span> (<span class="text-lowercase">m</span><sup>2</sup>)
            </div>
            <div v-on:click="sortBy('terrace')" class="pl-table-header-col col d-none d-md-block">
                <span v-once v-if="en">terrace</span><span v-else>terasa</span> (<span class="text-lowercase">m</span><sup>2</sup>)
            </div>
            <div v-on:click="sortBy('beds')" class="pl-table-header-col col d-none d-lg-block">
                <span v-once v-if="en">number of beds**</span><span v-else>počet lůžek**</span>
            </div>
            <div v-on:click="sortBy('state')" class="pl-table-header-col pl-col-max col d-none d-md-block">
                <span v-once v-if="en">status</span><span v-else>stav</span>
            </div>
            <div v-on:click="sortBy('availableFrom')" class="pl-table-header-col pl-col-max col d-none d-lg-block">
                <span v-once v-if="en">available from</span><span v-else>k dispozici od</span>
            </div>
            <div v-on:click="sortBy('price')" class="pl-table-header-col col">
                <span v-if="en">price/month(CZK)*</span>
                <span v-else>cena/měsíc (k<span class="text-lowercase">č</span>)*</span>
            </div>
            <div class="pl-table-header-col not-sortable col">
                <span v-once v-if="en">Detail</span>
                <span v-else>detail<br class="d-sm-none">bytu</span>
            </div>
            <!--<div class="pl-table-header-col not-sortable col">
                <span v-once v-if="en">favourites</span>
                <span v-else>do oblíbených</span>
            </div>-->
        </div> 
        
        <div v-for="flat in flatData" v-if="flat.visibility" class="pl-table-item row m-0">
            <div class="pl-table-item-col col cursor-pointer" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.name}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-lg-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.building ? flat.building : '-'}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-lg-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.floor}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-sm-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.orientation ? flat.orientation : '-'}}</div>
            <div class="pl-table-item-col col cursor-pointer text-lowercase" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.disposition}}</div>
            <div class="pl-table-item-col col cursor-pointer" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.area}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-md-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.balcony | dashZero}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-md-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.terrace | dashZero}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-lg-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')" v-bind:title="flat.beds">{{flat.bedsShort}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-md-block pl-col-max" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')" v-bind:title="flat.state">{{flat.state}}</div>
            <div class="pl-table-item-col col cursor-pointer d-none d-lg-block" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">{{flat.availableFrom}}</div>
            <div class="pl-table-item-col col cursor-pointer" v-on:click="redirectToFlatDetail(flat,'Řádek bytu')">
                <span>{{totalPrice(flat).toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, " ")}}</span>
            </div>
            <div class="pl-table-item-col col">
                <button class="d-none d-lg-inline-block btn btn-uni-dark w-90p" v-on:click="redirectToFlatDetail(flat,'Tlačítko Detail bytu')">
                    <span v-once v-if="en">Detail</span>                
                    <span v-once v-else>Detail bytu</span>
                </button>
                <button class="d-lg-none btn btn-uni-dark" v-on:click="redirectToFlatDetail(flat,'Tlačítko Detail bytu')"><img v-bind:src="gv.content_url+'/images/icons/search.png'" alt="Detail" width="16px" height="16px"></button>
            </div>
            <!--<div class="pl-table-item-col col d-flex justify-content-center">
                <button type="button" v-if="!flat.favorite" v-on:click="favorite('add', flat)" class="btn-hearth align-self-center"></button>
                <button type="button" v-if="flat.favorite" v-on:click="favorite('remove', flat) " class="btn-hearth active align-self-center"></button>
            </div>-->
        </div> 
        
        <div v-if="!pager.visibleFlats" class="text-center my-4">
            <span v-if="en" class="ff-saira text-uppercase fsz-22 text-danger">NO RESULTS MATCHING THE FILTER</span>
            <span v-else class="ff-saira text-uppercase fsz-22 text-danger">Filtru neodpovídá žádná jednotka</span>
        </div>
    </div>
       
    <div class="row" v-if="showFavorite.state">
        <div class="col">
            <button @click="hideFavorite()" class="btn btn-uni-back">
                <span v-once v-if="en">Back to list</span>                
                <span v-once v-else>Zpět na přehled</span>      
            </button>
        </div>
    </div>
        
    <div v-if="showFavorite.state || (filterData.view && filterData.view.cards)" class="row">
              
        <div v-if="showFavorite.state" class="pl-flat-card col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-center">
            <h2 v-once v-if="en" class="pl-favorite-title mt-5 mt-md-0 en">My<br class="d-none d-md-block"> favorite<br class="d-none d-md-block"> apartments</h2>
            <h2 v-once v-else class="pl-favorite-title mt-5 mt-md-0">Moje oblíbené byty</h2>
        </div>
        
        <div v-for="(flat, key) in flatData" v-if="isCardVisible(flat)" class="pl-flat-card col-12 col-md-6 col-lg-4">
            <div class="pl-flat-card-inner">
                <div>
                    <div class="pl-flat-card-image cursor-pointer">
                        <img v-bind:src="flat.mainImage700" alt="" v-on:click="redirectToFlatDetail(flat,'Karta bytu')">
                    </div>
                    <div class="pl-flat-card-title cursor-pointer" v-bind:class="getStateClass(flat.statusNum)" v-on:click="redirectToFlatDetail(flat,'Karta bytu')">
                        <h3>{{flat.name}}</h3>
                        <span>{{flat.state}}</span>
                    </div> 
                    <div class="pl-flat-card-disposition">{{flat.disposition}}</div>
                    <div class="pl-flat-card-info row">
                        <div class="col-auto pr-2">
                            <span v-once v-if="en">Building</span>
                            <span v-once v-else>Budova</span> {{flat.building}}
                        </div>
                        <div class="col text-center">{{flat.area}} <span class="text-lowercase">m</span><sup>2</sup></div>
                        <div class="col text-center">{{flat.floor}}. NP</div>
                    </div>
                    <div class="pl-flat-card-price" v-if="flat.price">
                        <span v-once v-if="en">{{totalPrice(flat).toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, " ")}} CZK / month</span>
                        <span v-once v-else>{{totalPrice(flat).toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, " ")}} kč / měsíc</span>
                    </div>
                </div>
                <div class="pl-flat-card-more">
                    <button class="btn btn-uni-dark px-4" v-on:click="redirectToFlatDetail(flat,'Tlačítko Detail bytu')">
                        <span v-once v-if="en">Apartment details</span>
                        <span v-once v-else>Detail bytu</span>
                    </button>
                </div>
            </div>
        </div>
        
        <div v-if="!loader && !pager.visibleFlats && !showFavorite.state" class="col text-center my-4">
            <span v-if="en" class="ff-saira text-uppercase fsz-22 text-danger">NO RESULTS MATCHING THE FILTER</span>
            <span v-else class="ff-saira text-uppercase fsz-22 text-danger">Filtru neodpovídá žádná jednotka</span>
        </div>
        
    </div>
    
    <div class="row" v-if="filterData.view.cards && !showFavorite.state && pager.visibleFlats > 6">
        <div class="col-12">
            <div class="pl-pager d-flex justify-content-center">
                <div class="pl-pager-prev"><button class="btn-invisible cursor-pointer" type="button" v-on:click="setPage('prev')"><i class="arr left"></i></button></div>
                <div class="pl-pager align-self-center">
                    <button v-for="(page, key) in pager.pages" v-bind:key="key"
                        v-on:click="setPage(key)"
                        v-bind:class="page ? 'active' : ''"
                        class="pl-pager-dot cursor-pointer"> </button>
                </div>
                <div class="pl-pager-next"><button class="btn-invisible cursor-pointer" type="button" v-on:click="setPage('next')"><i class="arr right"></i></button></div>
            </div>
            <div class="text-center text-black-50">
                <span>{{pager.actualPage + 1}}</span> - <span>{{pager.pages.length}}</span> 
            </div>
        </div>
    </div>
    
</div>
`
});

var pricelist = new Vue({

    el: '#pricelist',

    data: {
        gv: gv,
        en: gv.en,
        isMobile: isMobile(),
        loader: true,
        dataUrl: `${gv.root_url}/ajax/data/flats-list/?lang=${gv.lang}`,
        flatData: [],
        filterDataHelpers: {
            building: ["a1", "a2", "c1","c2","d"],
            disposition: ["1+kk", "1+1", "2+kk", "2+1"],
            type: ["standard", "premium"],
            floor: [1,2,3,4,5,6,7],
            area: ["to30", "from30to50", "above50"],
            beds: ["2x D", "2x S", "3x S", "4x S", "D", "D + 2x S"],
            accessories: ["terrace", "dishwasher", "washingMachine", "oven", "kitchenHood", "balcony"],
            price: ["from11", "from15", "from18"],
            onlyFree: true,
        },
        filterData: {
            view: {
                list: false,
                cards: true
            },
            building: {
                a1: {
                    value: "a1",
                    label: "A1",
                    state: false,
                    available: false
                },
                a2: {
                    value: "a2",
                    label: "A2",
                    state: false,
                    available: false
                },
                c1: {
                    value: "c1",
                    label: "C1",
                    state: false,
                    available: false
                },
                c2: {
                    value: "c2",
                    label: "C2",
                    state: false,
                    available: false
                },
                d: {
                    value: "d",
                    label: "D",
                    state: false,
                    available: false
                }
            },
            disposition: {
                "1+kk": {
                    value: "1+kk",
                    label: "1+KK",
                    state: false,
                    available: false
                },
                "1+1": {
                    value: "1+1",
                    label: "1+1",
                    state: false,
                    available: false
                },
                "2+kk": {
                    value: "2+kk",
                    label: "2+kk",
                    state: false,
                    available: false
                },
                "2+1": {
                    value: "2+1",
                    label: "2+1",
                    state: false,
                    available: false
                }
            },
            floor: {
                1: {
                    value: 1,
                    label: "1.NP",
                    state: false,
                    available: false
                },
                2: {
                    value: 2,
                    label: "2.NP",
                    state: false,
                    available: false
                },
                3: {
                    value: 3,
                    label: "3.NP",
                    state: false,
                    available: false
                },
                4: {
                    value: 4,
                    label: "4.NP",
                    state: false,
                    available: false
                },
                5: {
                    value: 5,
                    label: "5.NP",
                    state: false,
                    available: false
                },
                6: {
                    value: 6,
                    label: "6.NP",
                    state: false,
                    available: false
                },
                7: {
                    value: 7,
                    label: "7.NP",
                    state: false,
                    available: false
                }
            },
            price: {
                from11: {
                    min: 11000,
                    label: "od 11 000 Kč",
                    labelEn: "from CZK 11 000",
                    state: false,
                    available: false
                },
                from15: {
                    min: 15000,
                    label: "od 15 000 Kč",
                    labelEn: "from CZK 15 000",
                    state: false,
                    available: false
                },
                from18: {
                    min: 18000,
                    label: "od 18 000 Kč",
                    labelEn: "from CZK 18 000",
                    state: false,
                    available: false
                },
            },
            area: {
                to30: {
                    min: 0,
                    max: 29.99,
                    label: "do 30 m<sup>2</sup>",
                    labelEn: "to 30 m<sup>2</sup>",
                    state: false,
                    available: false
                },
                from30to50: {
                    min: 30,
                    max: 49.99,
                    label: "30 m<sup>2</sup> - 50 m<sup>2</sup>",
                    labelEn: "30 m<sup>2</sup> - 50 m<sup>2</sup>",
                    state: false,
                    available: false
                },
                above50: {
                    min: 50,
                    max: 9999,
                    label: "nad 50 m<sup>2</sup>",
                    labelEn: "over 50 m<sup>2</sup>",
                    state: false,
                    available: false
                }
            },
            beds: {
                "2x D": {
                    value: "2x D",
                    label: "2x D",
                    state: false,
                    available: false
                },
                "2x S": {
                    value: "2x S",
                    label: "2x S",
                    state: false,
                    available: false
                },
                "3x S": {
                    value: "3x S",
                    label: "3x S",
                    state: false,
                    available: false
                },
                "4x S": {
                    value: "4x S",
                    label: "4x S",
                    state: false,
                    available: false
                },
                "D": {
                    value: "D",
                    label: "D",
                    state: false,
                    available: false
                },
                "D + 2x S": {
                    value: "D + 2x S",
                    label: "D + 2x S",
                    state: false,
                    available: false
                }
            },
            accessories: {
                "terrace": {
                    value: "terrace",
                    label: "terasa",
                    labelEn: "terrace",
                    state: false,
                    available: true
                },
                "dishwasher": {
                    value: "dishwasher",
                    label: "myčka",
                    labelEn: "dishwasher",
                    state: false,
                    available: true
                },
                "washingMachine": {
                    value: "washingMachine",
                    label: "pračka",
                    labelEn: "washing machine",
                    state: false,
                    available: true
                },
                "oven": {
                    value: "oven",
                    label: "trouba",
                    labelEn: "oven",
                    state: false,
                    available: true
                },
                "kitchenHood": {
                    value: "kitchenHood",
                    label: "digestoř",
                    labelEn: "kitchen hood",
                    state: false,
                    available: true
                },
                "balcony": {
                    value: "balcony",
                    label: "balkon",
                    labelEn: "balcony",
                    state: false,
                    available: true
                }
            },
            onlyFree: {
                value: "free",
                label: "Jen volné",
                labelEn: "Only vacant",
                state: true,
                available: true
            },
            filterCollapsed: true,
            selectionCollapsed: true,
            selectionSelectedBuilding: "",
            selectionSelectedFloor: "",
            selectionSelectedFlatName: "",
            version: 63
        },
        showFavorite: {state: false},
        filterDataLoaded: false,
        favoritesStorageName: 'unicity-favorite-items',
        favoritesFlats: (isLocalStorageAvailable() && localStorage.getItem('unicity-favorite-items')) ? JSON.parse(localStorage.getItem('unicity-favorite-items')) : [],
    },

    methods: {
        getData()
        {
            this.loader = true;

            this.$http.get(this.dataUrl, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                    'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }).then(response => {
                this.flatData = response.body;
                this.loadFilterData();
                this.setPostFormFilterData();
                this.setFilterAvailability();

                setTimeout(() => {this.loader = false}, 500)
            });
        },

        setFilterAvailability()
        {
            // První nastavení viditelnosti filtrů
            // Obsahuje-li nějaký byt hodnotu filtru pak je filtr dostupný

            for (let i in this.filterData.building) { this.filterData.building[i].available = false }
            for (let i in this.filterData.disposition) { this.filterData.disposition[i].available = false }
            for (let i in this.filterData.floor) { this.filterData.floor[i].available = false }
            for (let i in this.filterData.area) { this.filterData.area[i].available = false }
            for (let i in this.filterData.beds) { this.filterData.beds[i].available = false }
            for (let i in this.filterData.accessories) { this.filterData.accessories[i].available = true }
            for (let i in this.filterData.price) { this.filterData.price[i].available = false }

            this.flatData.forEach((flat) => {

                this.favorite("check", flat);

                if (this.filterDataHelpers.building.length) {
                    let i = this.filterDataHelpers.building.indexOf(flat.building.toLowerCase());
                    if (i >= 0) {
                        this.filterData.building[this.filterDataHelpers.building[i]].available = true;
                        this.filterDataHelpers.building.splice(i, 1);
                    }
                }

                if (this.filterDataHelpers.disposition.length) {
                    let i = this.filterDataHelpers.disposition.indexOf(flat.disposition.toLowerCase());

                    if (i >= 0) {
                        this.filterData.disposition[this.filterDataHelpers.disposition[i]].available = true;
                        this.filterDataHelpers.disposition.splice(i, 1);
                    }
                }

                if (this.filterDataHelpers.floor.length) {
                    let i = this.filterDataHelpers.floor.indexOf(flat.floor);
                    if (i >= 0) {
                        this.filterData.floor[this.filterDataHelpers.floor[i]].available = true;
                        this.filterDataHelpers.floor.splice(i, 1);
                    }
                }

                if (this.filterDataHelpers.area.length) {
                    for (let p in this.filterData.area) {
                        if (this.filterData.area.hasOwnProperty(p)) {
                            if (flat.area > this.filterData.area[p].min && flat.area < this.filterData.area[p].max && !this.filterData.area[p].available) {
                                this.filterDataHelpers.area.splice(this.filterDataHelpers.area.indexOf(p), 1);
                                this.filterData.area[p].available = true;
                            }
                        }
                    }
                }

                if (this.filterDataHelpers.beds.length) {
                    let i = this.filterDataHelpers.beds.indexOf(flat.bedsShort);

                    if (i >= 0) {
                        this.filterData.beds[this.filterDataHelpers.beds[i]].available = true;
                        this.filterDataHelpers.beds.splice(i, 1);
                    }
                }

                if (this.filterDataHelpers.price.length) {
                    for (let p in this.filterData.price) {
                        if (this.filterData.price.hasOwnProperty(p)) {
                            if (flat.price >= this.filterData.price[p].min && this.filterDataHelpers.price.indexOf(p) > -1) {
                                this.filterDataHelpers.price.splice(this.filterDataHelpers.price.indexOf(p), 1);
                                this.filterData.price[p].available = true;
                            }
                        }
                    }
                }

                if (this.filterDataHelpers.onlyFree) {
                    if (flat.statusRaw === 'volný') {
                        this.filterDataHelpers.onlyFree = false;
                        this.filterData.onlyFree.available = true;
                    }
                }

            });
        },

        favorite(method, flat, target)
        {
            if (!isLocalStorageAvailable()) {
                console.warn("web storage disabled");
                return;
            }

            if (method === "add") {
                if (this.favoritesFlats.indexOf(flat.name) >= 0) return;
                this.favoritesFlats.push(flat.name);
                localStorage.setItem(this.favoritesStorageName, JSON.stringify(this.favoritesFlats));
                flat.favorite = true;
                favoriteHeartController.addFavorite();
            } else if (method === "remove") {
                if (this.favoritesFlats.indexOf(flat.name) < 0) return;
                this.favoritesFlats.splice(this.favoritesFlats.indexOf(flat.name), 1);
                localStorage.setItem(this.favoritesStorageName, JSON.stringify(this.favoritesFlats));
                flat.favorite = false;
                favoriteHeartController.removeFavorite();
            } else if (method === "check") {
                if (this.favoritesFlats.indexOf(flat.name) >= 0) {
                    flat.favorite = true;
                }
            }
        },

        getJsonFromUrl(url)
        {
            if(!url) url = location.search;
            let query = url.substr(1);
            let result = {};
            query.split("&").forEach(function(part) {
                let item = part.split("=");
                result[item[0]] = decodeURIComponent(item[1]);
            });
            return result;
        },

        getUrlAction()
        {

            if (location.hash === "#oblibene" || location.hash === "#favorite") {
                location.hash = "";

                setTimeout(() => {
                    this.showFavorite.state = true;
                    this.loader = false;
                }, 1000)
            } else {
                // this.loader = false;
            }


            /*
            this.params = this.getJsonFromUrl();
            if (typeof this.params.flat === "undefined") {
                this.loader = false;
                return;
            }
            this.paramsFlatLoaded = false;
            let flat = this.tryFindFlatByName(this.params.flat);
            if (flat.length) this.directShowDetail(flat[0]);
            */
        },

        tryFindFlatByName(name)
        {
            return this.flatData.filter(flat => {
                return flat.name.toLowerCase() === name.toLowerCase()
            });
        },

        saveFilterData()
        {
            try {
                localStorage.setItem('unicity-filter-data', JSON.stringify(this.filterData));
            } catch(e) { console.log(e); }
        },

        loadFilterData()
        {
            try {
                let d = localStorage.getItem('unicity-filter-data');
                if (typeof d === "string" && d !== "") {
                    d = JSON.parse(d);
                    if (d.version === this.filterData.version) this.filterData = d;
                }
            } catch(e) {
                console.log(e);
            }

            this.filterDataLoaded = true;
        },

        eachObject(obj, callBack)
        {
            for (let pp in obj) {
                if ( obj.hasOwnProperty(pp) ) {
                    callBack(obj[pp]);
                }
            }
        },

        resetFilters()
        {
            this.showFavorite.state = false;

            this.eachObject(this.filterData, (obj) => {
                if (typeof obj === "object") {
                    if (typeof obj.state !== "undefined") obj.state = false;
                    this.eachObject(obj, (o) => {
                        if (typeof o.state !== "undefined") o.state = false;
                    })
                }
            })
        },

        setPostFormFilterData(filterData)
        {
            if (typeof postFilterData === "undefined" && typeof filterData === "undefined") return;

            let pf = {};

            if (filterData) pf = filterData;
            else pf = postFilterData;

            let res = 0;

            if ((pf.disposition && (pf.disposition === "all" || this.filterData.disposition[pf.disposition].available))
                || (pf.state && (pf.state === "all" || this.filterData.onlyFree.available))
                || (pf.price && (pf.price === "all" || this.filterData.price[pf.price].available))) {
                this.resetFilters();
            }

            this.filterData.filterCollapsed = true;

            if (pf.disposition !== "all" && pf.disposition && this.filterData.disposition[pf.disposition].available) {
                this.filterData.disposition[pf.disposition].state = true;
                res = true;
            }
            if (pf.price !== "all" && pf.price && this.filterData.price[pf.price].available) {
                this.filterData.price[pf.price].state = true;
                res = true;
            }
            if (pf.state !== "all" && pf.state && this.filterData.onlyFree.available) {
                this.filterData.onlyFree.state = true;
                res = true;
            }

            return res;
        }
    },

    mounted() {
        this.getData();

        this.getUrlAction();
    },

    watch: {
        filterData: {
            deep: true,
            handler: function () {
                this.saveFilterData();
            }
        }
    },

    template:
`  
    <div class="container mt-5 pt-5 pl-wrapper">
        
        <div class="pl-loader" v-if="loader">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
                <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                        <stop stop-color="#ccc" stop-opacity="0" offset="0%"/>
                        <stop stop-color="#ccc" stop-opacity=".631" offset="63.146%"/>
                        <stop stop-color="#ccc" offset="100%"/>
                    </linearGradient>
                </defs>
                <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)">
                        <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2" transform="rotate(195.49 18 18)">
                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/>
                        </path>
                        <circle fill="#ccc" cx="36" cy="18" r="1" transform="rotate(195.49 18 18)">
                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/>
                        </circle>
                    </g>
                </g>
            </svg>
        </div>
        
        <div class="pl-table-container mt-4">
            <pricelist-selection v-if="!isMobile" :filterData="filterData" :flatData="flatData" :filterDataLoaded="filterDataLoaded" :showFavorite="showFavorite" ref="selection"></pricelist-selection>
            
            <pricelist-filter :filterData="filterData" :flatData="flatData" :filterDataLoaded="filterDataLoaded" :showFavorite="showFavorite" ref="filter"></pricelist-filter>
        
            <pricelist-table :filterData="filterData" :flatData="flatData" :favorite="favorite" :showFavorite="showFavorite" :loader="loader"></pricelist-table>
        </div>
         
        <!--<div class="pl-detail-container">-->
            <!--<pricelist-detail :flat="detailFlat" :toggleDetailPage="toggleDetailPage" :favorite="favorite" :detailFlatDisplay="detailFlatDisplay"></pricelist-detail>-->
        <!--</div>-->
        
    </div>
`
});
